import { createContext } from "react";

const defaultValue = {
  index: 0,
  setIndex: (index) => {},
  sectionRefs: [],
  handleSectionClick: (index) => {},
};

const appContext = createContext(defaultValue);
export const AppContextProvider = appContext.Provider;
export default appContext;
